import SkeletonSubCard from '../SubCard/Skeleton';
import styles from './../styles.module.scss';
import skeleton from './styles.module.scss';
export default function SkeletonStaticCard() {
  return (
    <div className={styles.container}>
      <div className={styles.container__header}>
        <div className={skeleton.container}>
          <div className={skeleton.chevron} />

          <div className={skeleton.text} />
        </div>
        <div className={skeleton.container}>
          <div className={skeleton.text} />

          <div className={skeleton.chevron} />
        </div>
      </div>
      <div className={styles.container__main}>
        <SkeletonSubCard />
        <SkeletonSubCard />
        <SkeletonSubCard />
      </div>
    </div>
  );
}
